import React from 'react'
import { SetModal, ModalType } from '../..'
import WithdrawalModal from '../WithdrawalModal'
import { useAppSelector } from '@/redux'

import RecordItem from '../RecordItem'
import { useGetBalanceQuery, initialBalance } from '../../walletSlice'
import WithdrawTitle from '../WithdrawTitle'
import Desc from './Desc'
import useWithdrawParams from './useWithdrawParams'
import { useGetUserInfoQuery } from '@/utils/slices/accountSlice'
import { Dialog } from 'antd-mobile'
import { WITHDRAWAL_TIPS } from '../../constants'
export default function Weekly({
  setModal,
  modalStatus,
}: {
  setModal: SetModal
  modalStatus: ModalType
}) {
  const { data: balance = initialBalance } = useGetBalanceQuery(1)
  const { collectionInfoFilled, idenAuthenticationed } = useAppSelector(
    (state) => state.user,
  )
  const { data: userInfo } = useGetUserInfoQuery()

  const withdrawParams = useWithdrawParams()
  const goWithdraw = () => {
    setModal(
      !idenAuthenticationed
        ? 'requiredIdentify'
        : !collectionInfoFilled
        ? 'requiredCollectionInfo'
        : 'withdrawaling',
    )
  }
  const handleWithdraw = () => {
    if (userInfo?.isMigrated) {
      Dialog.confirm({
        title: '提示',
        content: WITHDRAWAL_TIPS['week'],
        onConfirm: () => {
          goWithdraw()
        },
      })
    } else {
      goWithdraw()
    }
  }
  return (
    <div>
      <Desc></Desc>
      <WithdrawTitle
        text={`注意：每周${withdrawParams.timeRangeRaw[0]}~${withdrawParams.timeRangeRaw[1]}可提现1次，提现额度￥${withdrawParams.amountLimit[0]}~${withdrawParams.amountLimit[1]}元。`}
        disabled={!withdrawParams.available}
        onClick={handleWithdraw}
        title="周结钱包"
        balance={balance}
      ></WithdrawTitle>
      <RecordItem type="weekly-entry"></RecordItem>
      <RecordItem type="weekly-withdraw"></RecordItem>
      {modalStatus === 'withdrawaling' && (
        <WithdrawalModal
          visible={!!modalStatus}
          onFinishWithdrawal={() => setModal('')}
          walletType={1}
          withdrawParams={withdrawParams}
        ></WithdrawalModal>
      )}
    </div>
  )
}
